/**
 * [middleware]
 * Validação se a route acedida é necessario o utilizador estar autenticado.
 * Caso seja, então valida se de facto o utilizador esta autenticado naquele momento,
 *      Caso esteja permite avançar para a route acedida,
 *      Caso não esteja, redireciona para a route de login com a query da route acedida,
 *      de forma a quando o utilizador realizar o login voltar a essa mesma route.
 * Caso não seja, então valida se de facto não existe algum utilizador autenticado naquele momento
 *      Caso não esteja, permite avançar para a route acedida ( login, forgot, reset ),
 *      Caso esteja, redireciona para a route de index, de forma a evitar que um utilizador autenticado
 *      aceda novamente as páginas de autenticação.
 *
 * @since 1.0.0
 * @category middleware
 * @author Tiago Martinho
 *
 */
import Cookies from 'js-cookie';

export default async ( to, _, next ) => {
    // obtém das cookies se há algum utilizador.
    const haveCurrentUser = Cookies.get( 'currentUser' );

    ( to.matched.some( record => record.meta.requiresAuth ) )
        ? haveCurrentUser ? next() : next({ name: 'login', query: { redirect: to.path } })
        : !haveCurrentUser ? next() : next({ name: 'index' });
};